//Action

import {
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER,
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS,
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR,
} from "./actionType";

// Action Creator for Search Contact Person Lookup by Phone Number
export const searchContactPersonLookupByPhoneNumber = (payload) => ({
  type: SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER,
  payload,
});

export const searchContactPersonLookupByPhoneNumberSuccess = (payload) => ({
  type: SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS,
  payload,
});

export const searchContactPersonLookupByPhoneNumberError = (payload) => ({
  type: SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR,
  payload,
});
